import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class EditUploadsService {
  bankMasterForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    
    this.bankMasterForm = this.formBuilder.group({
      ledgerOwner: [null, [Validators.required]],
      ccy: [null, [Validators.required]],
      name: [null, [Validators.required]],
      account: [null, [Validators.required]],
      paymentAmount: ['', [Validators.required,Validators.pattern(/^-?\d*\.?\d+$/), Validators.maxLength(12)]],
      receiptAmount: ['', [Validators.required,Validators.pattern(/^-?\d*\.?\d+$/), Validators.maxLength(12)]],
      ledgerBalance: ['', [Validators.required,Validators.pattern(/^-?\d*\.?\d+$/), Validators.maxLength(12)]],
      date: [null, [Validators.required]],
      clearedStatus: [null],
      chequeNumber: ['', [Validators.pattern(/^-?\d*\.?\d+$/), Validators.maxLength(12)]],
      customerReference: [''],
      bankReference: [''],
      valueDate: [null, [Validators.required]],
      transactionDetails: [null, [Validators.required]],
      comments: [''],
      transactionType: [null],
    });
  }

}
